import { render, staticRenderFns } from "./cooperateData.vue?vue&type=template&id=63847814&scoped=true"
import script from "./cooperateData.vue?vue&type=script&lang=js"
export * from "./cooperateData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63847814",
  null
  
)

export default component.exports